var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-needs-popup', {
    attrs: {
      "data-to-show": _vm.isNewNeedPopupDisplayed,
      "limit": _vm.hasLimit ? 22 : null
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewNeedPopup(false);
      },
      "addNeed": function (newValue) {
        _vm.addNewNeed(newValue);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15"
  }, [_vm._v("Besoins au travail")]), _vm._v(" "), _c('div', {
    staticClass: "mx-10"
  }, [_vm.isErrorMaxLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n      Le nombre de besoins maximal a été atteint pour ce type de CV\n    ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n      Afin d'avoir un rendu visuel optimal, il faut sélectionner entre 3 et 5\n      besoins\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative w-max"
  }, [_c('add-button', {
    staticClass: "mb-8",
    attrs: {
      "libelle": "Ajouter un nouveau besoin"
    },
    on: {
      "add": function ($event) {
        return _vm.changeStateNewNeedPopup(true);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-3"
  }, _vm._l(_vm.defaultNeeds, function (dNeed, kda) {
    return _c('div', {
      key: 'default' + kda,
      staticClass: "col-span-full md:col-span-1 flex justify-center md:block"
    }, [_c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": (((_vm.form.data.needs || {}).value || {}).default || []).includes(dNeed) ? 'indigo-2' : 'white',
        "libelle": dNeed,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": (((_vm.form.data.needs || {}).value || {}).default || [])[kda] === dNeed ? 'minus-circle' : 'plus-circle',
        "icon-color": (((_vm.form.data.needs || {}).value || {}).default || [])[kda] === dNeed ? 'text-indigo-600' : 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true,
        "responsive": false
      },
      on: {
        "push": function ($event) {
          return _vm.displayDefaultNeed(dNeed);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('hr', {
    staticClass: "my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-3"
  }, _vm._l(_vm.persoNeeds, function (pNeed, kpa) {
    return _c('div', {
      key: 'perso' + kpa,
      staticClass: "col-span-full lg:col-span-1 flex justify-center md:block"
    }, [_c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": pNeed.isDisplayed ? 'indigo-2' : 'white',
        "libelle": pNeed.value,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": pNeed.isDisplayed ? 'minus-circle' : 'plus-circle',
        "icon-color": pNeed.isDisplayed ? 'text-indigo-600' : 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true
      },
      on: {
        "push": function ($event) {
          return _vm.displayPersoNeed(kpa);
        }
      }
    })], 1);
  }), 0)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }